import { SHADOW_LEVEL1, SHADOW_LEVEL3, Typography, styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import { APP_PROMO_BANNER_HEIGHT } from './constants';

export const Root = styled('div')({
  bottom: 0,
  left: 0,
  position: 'fixed',
  width: '100%',
  // Web messenger has z-index 100, so we need to set higher z-index for app promo banner.
  zIndex: 101,
});

export const Inner = styled('a', { shouldForwardProp: shouldForwardProp() })(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(2),
  boxShadow: SHADOW_LEVEL3,
  color: theme.palette.text.primary,
  display: 'flex',
  gap: theme.spacing(2),
  height: APP_PROMO_BANNER_HEIGHT,
  margin: theme.spacing(2),
  paddingRight: theme.spacing(1),
  textDecoration: 'none',
  '&:hover, &:active': {
    boxShadow: SHADOW_LEVEL1,
    color: theme.palette.text.primary,
    transition: theme.transitions.create(['box-shadows'], {
      duration: theme.transitions.duration.short,
    }),
  },
}));

export const CloseButton = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  padding: theme.spacing(2, 0),
  width: theme.spacing(7),
}));

export const OpenButton = styled(Typography)(({ theme }) => ({
  marginLeft: 'auto',
  padding: theme.spacing(3, 6),
}));
